var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "tag_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.72 20.27c.49.49 1.13.73 1.77.73v-.01c.64 0 1.28-.24 1.77-.73l8.23-8.23c.34-.33.52-.8.51-1.25V4.69c-.02-.93-.77-1.67-1.72-1.69h-6.04c-.43-.01-.94.18-1.27.51l-8.24 8.23c-.47.47-.73 1.1-.73 1.77s.26 1.3.73 1.77zm-3.57-7.11L13.31 5H19v5.69l-8.16 8.16c-.19.2-.51.2-.71 0l-4.98-4.98a.47.47 0 0 1-.15-.35c0-.08.02-.23.15-.36m7.84-4.43a2.279 2.279 0 1 0 4.56 0 2.279 2.279 0 1 0-4.56 0m1.5 0a.781.781 0 0 1 1.56 0 .781.781 0 0 1-1.56 0",
  clipRule: "evenodd"
})));
export default SvgTag;